import {Injectable, OnDestroy} from '@angular/core';
import {Subscription} from 'rxjs';
import {finalize} from 'rxjs/operators';
import {LoaderService} from '../loader.service';
import {ToolsService} from '../tools.service';
import {UrlBuilderService} from '../url-builder.service';
import {SearchSuggestTypesEnum} from '../../enums/SearchEnums';
import {LoaderQueueItem} from '../../types/LoaderQueueItem';
import {SearchSuggestItem} from '../../types/SearchSuggestItem';
import {SearchSuggestPayload} from '../../types/SearchSuggestPayload';
import {SearchService} from '../search/search.service';

@Injectable({
  providedIn: 'root',
})
export class SearchWidgetFreeSearchResolverService implements OnDestroy {
  private subscriptions: Subscription[] = [];

  constructor(
    private searchService: SearchService,
    private tools: ToolsService,
    private urlBuilder: UrlBuilderService,
    private loaderService: LoaderService,
  ) {}

  public ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  public SolveFreeSearchTerm(term: string, successCallback: Function, failCallback: Function): void {
    const queryId: number = this.loaderService.generateQueueId();
    const queryItem: LoaderQueueItem = {
      id: queryId,
      title: '',
      description: '',
    };
    this.loaderService.addToQueue(queryItem);
    const suggestPayload: SearchSuggestPayload = {
      term: encodeURIComponent(term),
      size: 10,
    };
    this.subscriptions.push(
      this.searchService
        .freeSearchSuggest(suggestPayload)
        .pipe(
          finalize(() => {
            this.loaderService.removeFromQueue(queryId);
          }),
        )
        .subscribe(
          (result) => this.processSuggestData(result, term, successCallback, failCallback),
          (error) => console.error(error),
        ),
    );
  }

  private processSuggestData(
    result: SearchSuggestItem[],
    term: string,
    successCallback: Function,
    failCallback: Function,
  ): void {
    let matchedElement: SearchSuggestItem = null;
    if (!this.tools.isNil(result) && result.length > 0) {
      matchedElement = this.getMatchedElementFromResults(result, term);
    }
    if (!this.tools.isNil(matchedElement)) {
      successCallback(matchedElement);
      // this.redirectToSearchResultsWithCriteriaSelectedBySuggestItem(matchedElement);
    } else {
      failCallback();
      // this.standardSearchBtnClickAction();
    }
  }

  private getMatchedElementFromResults(result: SearchSuggestItem[], term: string): SearchSuggestItem {
    let matchedElement: SearchSuggestItem = null;
    result.forEach((selectedObject) => {
      if (
        this.tools.isNil(matchedElement) &&
        selectedObject.searchValue[0].type !== SearchSuggestTypesEnum.CAREPROVIDER_UNIT
      ) {
        matchedElement = this.getMatchedElementFromResultOrNull(selectedObject, term);
      }
    });
    return matchedElement;
  }

  private getMatchedElementFromResultOrNull(selectedObject: SearchSuggestItem, term: string): SearchSuggestItem {
    let matchedElement: SearchSuggestItem = null;
    const findEl: string = selectedObject.suggest.input.find(
      (item) => item === term.toLowerCase() || item === this.urlBuilder.NormalizeText(term, true),
    );
    if (!this.tools.isNil(findEl)) {
      matchedElement = selectedObject;
    }
    return matchedElement;
  }
}
